import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "MoodCalendar",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getMoodCalendar, getMoodCalendarError, getMoodCalendarSuccess } =
  slice.actions;

reducerRegistry.register("moodCalendar", reducer);
